


































































import Vue, { PropType } from 'vue';
import { formatDateString } from '@/helpers/formatters';
import {
  isRgValid,
  isDateStringValid,
  isDateLessOrEqualToday,
  isDateMoreOrEqualBirthdate,
} from '@/helpers/validators';
import { AutoCompleteInput, OutlinedTextInput, OutlinedSelect } from '@descomplica/vue-components';
import { AutocompleteOption, parseToAutocompleteOption } from '@/helpers/autocomplete';

export interface IdentificationDocumentFormEvent {
  rg: string;
  issueDate: string;
  issuer: string;
  issueState: string;
  motherName: string;
  fatherName: string;
}

export default Vue.extend({
  components: { AutoCompleteInput, OutlinedTextInput, OutlinedSelect },
  props: {
    currentRg: {
      type: String,
      default: '',
    },
    currentIssueDate: {
      type: String,
      default: '',
    },
    currentIssuer: {
      type: String,
      default: '',
    },
    currentIssueState: {
      type: String,
      default: '',
    },
    currentMotherName: {
      type: String,
      default: '',
    },
    currentFatherName: {
      type: String,
      default: '',
    },
    issueStateOptions: {
      type: Array as PropType<string[]>,
      default: [],
    },
    issuerOptions: {
      type: Array as PropType<AutocompleteOption[]>,
      default: [],
    },
  },
  data() {
    return {
      form: {
        rg: this.currentRg,
        issueDate: this.currentIssueDate,
        issuer: this.currentIssuer,
        issueState: this.currentIssueState,
        motherName: this.currentMotherName,
        fatherName: this.currentFatherName,
      },
      masks: {
        date: formatDateString,
      },
      errors: {
        rg: false,
        issueDate: false,
        issuer: false,
      },
    };
  },
  computed: {
    selectedIssuer(): AutocompleteOption {
      return parseToAutocompleteOption(this.form.issuer);
    },
  },
  methods: {
    inputHandler() {
      this.errors.rg = !!this.form.rg && !isRgValid(this.form.rg);

      this.errors.issueDate =
        (!!this.form.issueDate && !isDateStringValid(this.form.issueDate)) ||
        !isDateLessOrEqualToday(this.form.issueDate) ||
        !isDateMoreOrEqualBirthdate(
          this.form.issueDate,
          this.$store.getters.personalData?.birthDate,
        );

      const hasErrors = this.errors.rg || this.errors.issueDate;

      const event: IdentificationDocumentFormEvent = { ...this.form };

      this.$emit('input', event, hasErrors);
    },
    selectHandlerIssuer(option: AutocompleteOption) {
      this.form.issuer = option.value;
      this.inputHandler();
    },
  },
});
